import React from "react";
import "../../../styles/Auth/viewInvoicePopup.css";

const ViewInvoicePopup = ({ data, onClose }) => {
    if (!data) return null;

    // 🧮 Merge payment methods for clean display
    const groupedPayments = {};
    data.payments?.forEach((p) => {
        const method = p.paymentMethod || "Unknown";
        groupedPayments[method] = (groupedPayments[method] || 0) + Number(p.amount || 0);
    });

    const paymentSummary = Object.entries(groupedPayments)
        .map(([method, amt]) => `${method}: ₹${amt.toLocaleString("en-IN")}`)
        .join(", ");

    const item = data.items?.[0];
    const product = item?.productId || {};

    return (
        <div className="view-popup-overlay">
            <div className="view-popup-wrapper">
                <div className="view-invoice-popup-card">

                    {/* 🧾 Header */}
                    <h5 className="view-invoice-title">Invoice Details</h5>
                    <p className="view-invoice-subtitle">Invoice No: #{data.invoiceNo}</p>

                    {/* 🧍 Customer Info */}
                    <div className="invoice-customer-section">
                        <img
                            src={`${process.env.REACT_APP_API_URL}${data.customerId?.customerImageObject?.uri}` || "/assets/placeholder.png"}
                            alt="customer"
                            className="invoice-customer-image"
                        />
                        <div className="invoice-customer-info">
                            <h6>{data.customerId?.name}</h6>
                            <p>{data.customerId?.phoneNumber}</p>
                            <p>{data.customerId?.city ? `${data.customerId?.city}, ` : ""}{data.customerId?.state}</p>
                            <p>{data.customerId?.email}</p>
                        </div>
                    </div>

                    {/* 🧺 Product Info */}
                    <div className="invoice-product-section">
                        <h6>Items</h6>
                        <div className="invoice-product-card">
                            <img
                                src={`${process.env.REACT_APP_API_URL}${product.productImageObject?.uri}` || "/assets/placeholder.png"}
                                alt={product.title}
                                className="invoice-product-image"
                            />

                            <div className="invoice-product-details">
                                <h6>{product.title}</h6>
                                <p>{product.description}</p>

                                <div className="invoice-product-stats">
                                    <div><strong>Qty:</strong> {item.qty}</div>
                                    <div><strong>Rate:</strong> ₹{item.rate}</div>
                                    <div><strong>Tax:</strong> {item.tax}%</div>
                                    <div><strong>Discount:</strong> {item.discType}{item.disc}</div>
                                    <div><strong>Value:</strong> ₹{item.value}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 💰 Totals */}
                    <div className="invoice-total-section">
                        <h6>Totals</h6>
                        <div className="invoice-total-grid">
                            <div><strong>Items:</strong> {data.totals?.items}</div>
                            <div><strong>Quantity:</strong> {data.totals?.qty}</div>
                            <div><strong>Discount:</strong> ₹{data.totals?.overallDiscAmount}</div>
                            <div><strong>CGST:</strong> ₹{data.totals?.totalCGST?.toFixed(2)}</div>
                            <div><strong>SGST:</strong> ₹{data.totals?.totalSGST?.toFixed(2)}</div>
                            <div><strong>Net Value:</strong> ₹{data.totals?.netValue?.toLocaleString("en-IN")}</div>
                        </div>
                    </div>

                    {/* 💳 Payment Info */}
                    <div className="invoice-payment-section">
                        <h6>Payment Details</h6>
                        <p>{paymentSummary || "No payments recorded"}</p>
                    </div>

                    {/* Close Button */}
                    <button className="invoice-close-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default ViewInvoicePopup;
